var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1335_17565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.160156 7.02455C0.160156 3.5824 2.95057 0.791992 6.39271 0.791992H37.5555C40.9976 0.791992 43.788 3.5824 43.788 7.02455V25.7222C43.788 29.1644 40.9976 31.9548 37.5555 31.9548H6.39271C2.95057 31.9548 0.160156 29.1644 0.160156 25.7222V7.02455Z",
    fill: "#FAFAFA",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.939226 7.02455C0.939226 4.01267 3.38083 1.57106 6.39271 1.57106H37.5555C40.5674 1.57106 43.009 4.01267 43.009 7.02455V25.7222C43.009 28.7341 40.5674 31.1757 37.5555 31.1757H6.39271C3.38083 31.1757 0.939226 28.7341 0.939226 25.7222V7.02455Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.3,
    strokeWidth: 1.55814
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6759 1.57129H11.4549V31.1759H10.6759V21.8271H0.9375V21.048H10.6759V11.6992H0.9375V10.9201H10.6759V1.57129Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8793 21.048H43.0073V21.8271H32.8793V31.1759H32.1003V15.5945C32.1003 13.0129 34.1931 10.9201 36.7747 10.9201H43.0073V11.6992H36.7747C34.6234 11.6992 32.8793 13.4432 32.8793 15.5945V21.048Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8793 1.57129H32.1003V7.80384H32.8793V1.57129Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4259 16.3736C27.4259 19.3855 24.9843 21.8271 21.9724 21.8271C18.9605 21.8271 16.5189 19.3855 16.5189 16.3736C16.5189 13.3617 18.9605 10.9201 21.9724 10.9201C24.9843 10.9201 27.4259 13.3617 27.4259 16.3736ZM26.6468 16.3736C26.6468 18.9552 24.554 21.048 21.9724 21.048C19.3908 21.048 17.298 18.9552 17.298 16.3736C17.298 13.792 19.3908 11.6992 21.9724 11.6992C24.554 11.6992 26.6468 13.792 26.6468 16.3736Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1335_17565",
    x: -19.3166,
    y: -18.6847,
    width: 82.5824,
    height: 70.1166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.73837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1335_17565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1335_17565",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/Chip.d8b244910991e63f974244751d172846.svg";
export { ForwardRef as ReactComponent };